var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.97876,
    y: 9.97852,
    width: 27.0426,
    height: 29.6596,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3581 8.69435H33.75V10.9721H36.0278V39.4444H10.9722V10.9721H13.25V8.69435H10.9722C10.6933 8.65401 10.409 8.67328 10.1381 8.75088C9.8672 8.82848 9.61582 8.96266 9.40057 9.14455C9.18531 9.32644 9.01108 9.55191 8.88936 9.80608C8.76765 10.0603 8.70122 10.3373 8.69446 10.6191V39.7974C8.69595 40.0517 8.74751 40.3031 8.84619 40.5375C8.94486 40.7718 9.08873 40.9844 9.26958 41.1631C9.45042 41.3419 9.66469 41.4832 9.90017 41.5791C10.1356 41.675 10.3877 41.7236 10.642 41.7221H36.3581C36.6123 41.7236 36.8644 41.675 37.0999 41.5791C37.3353 41.4832 37.5496 41.3419 37.7305 41.1631C37.9113 40.9844 38.0552 40.7718 38.1538 40.5375C38.2525 40.3031 38.3041 40.0517 38.3056 39.7974V10.6191C38.3041 10.3648 38.2525 10.1133 38.1538 9.87902C38.0552 9.64469 37.9113 9.43209 37.7305 9.25336C37.5496 9.07464 37.3353 8.93328 37.0999 8.83736C36.8644 8.74145 36.6123 8.69285 36.3581 8.69435Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5957 8.6958H34.4042V10.9736H12.5957V8.6958Z",
    fill: "#858585"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5745,
    y: 7.36182,
    width: 7.85106,
    height: 30.5319,
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6111 11.3487C32.6081 10.6459 32.3276 9.97267 31.8306 9.47567C31.3336 8.97867 30.6604 8.69813 29.9575 8.69513H27.9075C27.6566 7.71521 27.0867 6.84667 26.2877 6.22643C25.4886 5.60619 24.5059 5.26953 23.4943 5.26953C22.4828 5.26953 21.5 5.60619 20.701 6.22643C19.9019 6.84667 19.332 7.71521 19.0811 8.69513H17.0425C16.3397 8.69813 15.6665 8.97867 15.1695 9.47567C14.6725 9.97267 14.3919 10.6459 14.3889 11.3487V15.5285H32.6111V11.3487ZM30.3334 13.2507H16.6667V11.3487C16.6667 11.2994 16.6764 11.2505 16.6953 11.2049C16.7142 11.1593 16.7419 11.1179 16.7768 11.083C16.8117 11.0481 16.8531 11.0204 16.8987 11.0015C16.9443 10.9826 16.9932 10.9729 17.0425 10.9729H21.2222V9.83402C21.2222 9.22991 21.4622 8.65055 21.8894 8.22339C22.3166 7.79622 22.8959 7.55624 23.5 7.55624C24.1041 7.55624 24.6835 7.79622 25.1107 8.22339C25.5378 8.65055 25.7778 9.22991 25.7778 9.83402V10.9729H29.9575C30.0572 10.9729 30.1528 11.0125 30.2233 11.083C30.2938 11.1535 30.3334 11.2491 30.3334 11.3487V13.2507Z",
    fill: "#858585"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5277 18.9438H31.4722V21.2216H15.5277V18.9438Z",
    fill: "#858585"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5277 23.5H31.4722V25.7778H15.5277V23.5Z",
    fill: "#858585"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5277 28.0562H31.4722V30.3339H15.5277V28.0562Z",
    fill: "#858585"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5277 32.6118H31.4722V34.8896H15.5277V32.6118Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.7b3db372ebd1d31a1e9694690699305c.svg";
export { ForwardRef as ReactComponent };